(function () {
  'use strict';

  if (window.PGThemePopupSuccessV56) return;
  window.PGThemePopupSuccessV56 = true;

  var updateQueued = false;

  function refreshFancybox() {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(function () {
      updateQueued = false;
      try {
        var $ = window.jQuery;
        var instance = $ && $.fancybox && $.fancybox.getInstance ? $.fancybox.getInstance() : null;
        if (instance && typeof instance.update === 'function') instance.update();
      } catch (error) {}

      try {
        window.dispatchEvent(new Event('resize'));
      } catch (error) {}
    });
  }

  function compactSuccess(root) {
    if (!root || !root.querySelector('.pg-newsletter-success')) return false;

    root.classList.add('pg-newsletter-popup--success-v56');
    root.scrollTop = 0;

    var shell = root.closest('.fancybox-content');
    if (shell) shell.classList.add('pg-newsletter-success-shell-v56');

    var content = root.querySelector('.pg-newsletter-popup__content');
    if (content) content.scrollTop = 0;

    refreshFancybox();
    return true;
  }

  function scan() {
    document.querySelectorAll('.pg-newsletter-popup').forEach(compactSuccess);
  }

  function boot() {
    scan();

    if (window.MutationObserver && document.body) {
      new MutationObserver(scan).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('.pg-newsletter-popup')) return;
      [0, 120, 350, 750, 1500].forEach(function (delay) {
        window.setTimeout(scan, delay);
      });
    }, true);

    document.addEventListener('shopify:section:load', scan);
    window.addEventListener('pageshow', scan, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
